import * as React from 'react';

import {Button} from 'shells/button/button';

import type {UserEmail, SmtpSettingsUpdateInputFieldInput} from 'nutshell-graphql-types';

import {SubmitSmtp} from './submit-smtp';

type Props = {
    disabled: boolean;
    smtpSettings: SmtpSettingsUpdateInputFieldInput;
    onVerificationFailure: (arg1: UserEmail) => void;
    onSuccess: (arg1: UserEmail) => void;
    onError: (errorMessage: string) => void;
    onVerificationTimeout: () => void;
};

// @ts-expect-error
export const SmtpSubmitButton = React.forwardRef<Props, HTMLButtonElement>((props: Props, ref) => {
    return (
        <SubmitSmtp
            onVerificationFailure={props.onVerificationFailure}
            onVerificationTimeout={props.onVerificationTimeout}
            onError={props.onError}
            onVerificationSuccess={props.onSuccess}
            smtpSettings={props.smtpSettings}
        >
            {({updateAndTest, inProgress}) => {
                function handleClick() {
                    updateAndTest();
                }

                return (
                    <Button
                        getButtonRef={ref}
                        variant='primary'
                        size='big'
                        disabled={props.disabled}
                        onClick={handleClick}
                    >
                        {inProgress ? 'Connecting…' : 'Connect and test'}
                    </Button>
                );
            }}
        </SubmitSmtp>
    );
});
